import React, { createContext, useContext, ReactNode } from "react";
import { useAuth, type User } from "@auth/frontend";
import { useAgents, type Agent } from "@agentic_system/api/agent";

interface AdminChatContextValue {
  user: User | null;
  agents: Agent[] | undefined;
  isLoadingAgents: boolean;
  isAdminMode: true;
}

export const AdminChatContext = createContext<AdminChatContextValue | null>(null);

export function AdminChatProvider({ children }: { children: ReactNode }) {
  const { user, isLoading: isLoadingAuth } = useAuth();
  const { data: agents, isLoading: isLoadingAgents } = useAgents();

  const value: AdminChatContextValue = {
    user,
    agents,
    isLoadingAgents: isLoadingAuth || isLoadingAgents,
    isAdminMode: true,
  };

  return (
    <AdminChatContext.Provider value={value}>
      {children}
    </AdminChatContext.Provider>
  );
}

export function useAdminChat(): AdminChatContextValue | null {
  return useContext(AdminChatContext);
}
